import {
  listAvailablePaymentBatches,
  createPaymentBatch,
  listPaymentBatches,
  getPaymentBatchDetail,
  confirmPaymentBatch,
  cancelPaymentBatch
} from '@/api/paymentbatch'

export const PAYMENT_BATCH_STATUS = {
  PENDING: 0,
  PAID: 1,
  CANCELLED: 3
}

export const PAYMENT_BATCH_STATUS_TEXT = {
  0: '待打款',
  1: '已打款',
  3: '已取消'
}

export const PAYMENT_BATCH_STATUS_TYPE = {
  0: 'warning',
  1: 'success',
  3: 'info'
}

export const PAY_CHANNELS = [
  { label: '银行卡', value: 'BankCard' },
  { label: '微信', value: 'Wechat' },
  { label: '支付宝', value: 'Alipay' },
  { label: 'Paypal', value: 'Paypal' }
]

const state = {
  availableBatches: [],
  paymentList: [],
  paymentTotal: 0,
  currentPayment: null,
  currentSettlementBatches: []
}

const mutations = {
  SET_AVAILABLE_BATCHES(state, list) {
    state.availableBatches = list || []
  },
  SET_PAYMENT_LIST(state, { list, total }) {
    state.paymentList = list || []
    state.paymentTotal = total || 0
  },
  SET_CURRENT_PAYMENT(state, { payment, settlement_batches }) {
    state.currentPayment = payment
    state.currentSettlementBatches = settlement_batches || []
  },
  CLEAR_CURRENT_PAYMENT(state) {
    state.currentPayment = null
    state.currentSettlementBatches = []
  }
}

const actions = {
  async fetchAvailableBatches({ commit }) {
    const res = await listAvailablePaymentBatches()
    commit('SET_AVAILABLE_BATCHES', res.data)
    return res.data
  },

  async createPayment(_, payload) {
    const res = await createPaymentBatch(payload)
    return res.data
  },

  async fetchPaymentList({ commit }, params = {}) {
    const res = await listPaymentBatches(params)
    commit('SET_PAYMENT_LIST', {
      list: res.data?.list,
      total: res.data?.total
    })
    return res.data
  },

  async fetchPaymentDetail({ commit }, id) {
    const res = await getPaymentBatchDetail(id)
    commit('SET_CURRENT_PAYMENT', res.data || {})
    return res.data
  },

  async confirmPayment(_, payload) {
    return await confirmPaymentBatch(payload)
  },

  async cancelPayment(_, payload) {
    return await cancelPaymentBatch(payload)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}